module.exports = __webpack_public_path__ + "static/Download-1461423f22476023a99bf638073bfc86.gif";